import Cookies from 'js-cookie';

const AUTH_COOKIE_OPTIONS = {
  path: '/',
  sameSite: 'lax',
  expires: 2,
};

export function setUserEmail(email) {
  Cookies.set('contact_email', email, AUTH_COOKIE_OPTIONS);
}

export function getUserEmail() {
  return Cookies.get('contact_email');
}

export function setContactVerified(isVerified) {
  Cookies.set('contact_verified', isVerified ? '1' : '0', AUTH_COOKIE_OPTIONS);
}

export function getContactVerified() {
  return Cookies.get('contact_verified') === '1';
}

export function clearUserEmail() {
  Cookies.remove('contact_email', { path: '/' });
  Cookies.remove('contact_verified', { path: '/' });
}
